import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
//引入element-plus官方样式
import 'element-plus/dist/index.css';

createApp(App).use(router).mount('#app')
